import Adicionar from './Adicionar';
import AlterarMinhaSenha from './AlterarMinhaSenha';
import AlterarSenha from './AlterarSenha';
import Default from './Default';
import Editar from './Editar';
import Login from './Login';

export default Default;

export const UsuariosAdicionar = Adicionar;
export const UsuariosEditar = Editar;
export const UsuariosLogin = Login;
export const UsuariosAlterarSenha = AlterarSenha;
export const UsuariosAlterarMinhaSenha = AlterarMinhaSenha;
